import { render } from "./my_tasks.html?vue&type=template&id=0017cdc4&external"
import script from "./my_tasks.js?vue&type=script&lang=js&external"
export * from "./my_tasks.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__